import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

const state = {
  commonObj: {
    hasDropdownLoaded: false,
    tradeTariffCountryList: [],
    applicationTypeList: [],
    capitalInfoList: [],
    currencyList: [],
    regionList: [],
    productList: [],
    unitMeasurementList: [],
    sectionNoList: [],
    chapterNoList: [],
    headingList: [],
    subHeadingList: [],
    portTypeList: Custom.portTypeList,
    coverageOfAgreementList: Custom.coverageOfAgreementList,
    statusOfAgreementList: Custom.statusOfAgreementList,
    productTypeList: Custom.productTypeList,
    subjectList: []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
